import { render, staticRenderFns } from "./overburdenComponent.vue?vue&type=template&id=4f10d609&"
import script from "./overburdenComponent.vue?vue&type=script&lang=js&"
export * from "./overburdenComponent.vue?vue&type=script&lang=js&"
import style0 from "./overburdenComponent.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports